import Notice from "~/components/shared/Notice/Notice";
import { Job } from "~/components/build/Show/lib/types";

interface Props {
  job: Job;
}

const StackFinished = ({ job }: Props) => {
  if (!job.stackFinished) {
    return null;
  }
  const message = "This job has been finished successfully by agent stack.";

  return (
    <div className="pb-4 pt-4">
      <Notice title={message} noticeType="notice" icon="heroicons/16/solid/exclamation-triangle">
        <p>
          {" "}
          Check the <strong>Timeline</strong> tab for more information.{" "}
        </p>
      </Notice>
    </div>
  );
};

export default StackFinished;
